module.exports = __webpack_public_path__ + "img/delete.249ac41e.svg";